import { keepPreviousData } from '@tanstack/react-query';
import { getRevenueVATCells } from 'api/v2/revenues';
import { getExpenseVATCells } from 'api/v3/expenses';
import { cleanExpenseDataForTaxImpact } from 'components/pages/Expenses/Form/utils';
import { cleanInvoiceForTaxImpact } from 'components/pages/Revenues/OtherRevenueForm/utils';
import useSuperQuery from 'hooks/useSuperQuery';
import { ExpensesCacheKeys, RevenuesCacheKeys } from 'types/cacheKeys.types';
import type { IExpenseFormValuesV2 } from 'types/expenses.types';
import type { Invoice, InvoiceFormValues } from 'types/invoice.types';
import { ONE_MINUTE } from 'utils/time';

export type UseExpenseVATCellsOptions = {
  expense: IExpenseFormValuesV2;
  enabled: boolean;
};

export type UseInvoiceVATCellsOptions = {
  invoice: InvoiceFormValues;
  enabled: boolean;
};

type ResultType = {
  key: string;
  value: number;
}[];

export const useExpenseVATCells = (props: UseExpenseVATCellsOptions) => {
  return useSuperQuery<ResultType>({
    queryKey: [ExpensesCacheKeys.ExpenseVATCells, props.expense, props.enabled],
    queryFn: () => {
      if (!props.enabled) {
        return [];
      }
      return getExpenseVATCells(cleanExpenseDataForTaxImpact(props.expense));
    },
    debounceTime: 500,
    gcTime: ONE_MINUTE,
    placeholderData: keepPreviousData,
  });
};

export const useInvoiceVATCells = (props: UseInvoiceVATCellsOptions) => {
  return useSuperQuery<ResultType>({
    queryKey: [
      RevenuesCacheKeys.RevenuesVATCells,
      props.invoice,
      props.enabled,
    ],
    queryFn: () => {
      if (!props.enabled) {
        return [];
      }
      return getRevenueVATCells(
        cleanInvoiceForTaxImpact(props.invoice) as Partial<Invoice>,
      );
    },
    debounceTime: 500,
    gcTime: ONE_MINUTE,
    placeholderData: keepPreviousData,
  });
};
